import { IBoatForLocality, IUpdateCustomerVesselMapping, IVesselClient } from 'src/generated-types/vessel'
import { useGet, usePut } from './reactQuery'

const baseUrl = (customerId: EntityId, localityId: EntityId) => `customers/${customerId}/localities/${localityId}/vessels`

const vesselAdminEndpoints = {
  getVesselClients() {
    return 'admin/vessel-clients'
  },
  updateCustomerVesselMapping(customerId: EntityId) {
    return `admin/customers/${customerId}/vessel-mapping`
  },
}

const vesselEndpoints = {
  getBoatsForLocality(customerId: EntityId, localityId: EntityId) {
    return baseUrl(customerId, localityId)
  }
}

export const useGetVesselClients = () => useGet<IVesselClient[]>(vesselAdminEndpoints.getVesselClients())

export const useUpdateCustomerVesselMapping = (customerId: EntityId) =>
  usePut<void, IUpdateCustomerVesselMapping>(vesselAdminEndpoints.updateCustomerVesselMapping(customerId))

export const useGetBoatsForLocality = (
  customerId: EntityId,
  localityId: EntityId,
  options?: { enabled?: boolean },
) =>
  useGet<IBoatForLocality[]>(vesselEndpoints.getBoatsForLocality(customerId, localityId), undefined, {
    enabled: options?.enabled !== false,
  })
